var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.625V11.625C16.5 14.25 15 15.375 12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H9",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.75L7.5975 8.625C8.37 9.24 9.6375 9.24 10.41 8.625",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6099 2.11508L14.8199 2.54257C14.9249 2.75257 15.1874 2.94758 15.4199 2.99258L15.7049 3.03758C16.5599 3.18008 16.7624 3.81008 16.1474 4.43258L15.8849 4.69507C15.7124 4.87507 15.6149 5.22007 15.6674 5.46007L15.7049 5.61758C15.9374 6.65258 15.3899 7.05007 14.4899 6.51007L14.2949 6.39757C14.0624 6.26257 13.6874 6.26257 13.4549 6.39757L13.2599 6.51007C12.3524 7.05757 11.8049 6.65258 12.0449 5.61758L12.0824 5.46007C12.1349 5.22007 12.0374 4.87507 11.8649 4.69507L11.6024 4.43258C10.9874 3.81008 11.1899 3.18008 12.0449 3.03758L12.3299 2.99258C12.5549 2.95508 12.8249 2.75257 12.9299 2.54257L13.1399 2.11508C13.5449 1.29758 14.2049 1.29758 14.6099 2.11508Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsStar);
export default __webpack_public_path__ + "static/media/sms-star.6c332f7887c4b867c75e16c8e749a30f.svg";
export { ForwardRef as ReactComponent };